import React, { ReactElement, ReactNode } from "react";
import { Progress } from "reactstrap";

interface StepsControlProps {
  value: number;
  max: number;
  left?: ReactNode;
  right?: ReactNode;
}

const StepsControl = (props: StepsControlProps): ReactElement | null => {
  if (props.value <= 0) {
    return null;
  }
  return (
    <div className="d-flex align-items-center py-2">
      { props.left && (
        <div className="align-self-center me-2">{props.left}</div>
      )}
      <div className="flex-fill fw-bold">
        {props.value <= props.max && (
          <Progress max={props.max} value={props.value}>
            Step {props.value} of {props.max}
          </Progress>
        )}
      </div>
      { props.right && (
        <div className="align-self-center ms-2">{props.right}</div>
      )}
    </div>
  );
};

export default StepsControl;
